import React, { useEffect, useState } from 'react';
import { ActivityIndicator, View } from 'react-native';

import { useAuth } from '@hooks/auth';
import { useNavigation } from '@react-navigation/native';
import { StackScreenProps } from '@react-navigation/stack';

import { Container } from './styles';

type Props = StackScreenProps<AuthStackParamList, 'Callback'>;

const Callback: React.FC<Props> = ({ route }) => {
  const [error, setError] = useState(false);
  const { setToken } = useAuth();
  const navigation = useNavigation();

  useEffect(() => {
    async function setTokenData(): Promise<void> {
      try {
        await setToken({ code: route.params.code });
        navigation.reset({
          index: 0,
          routes: [{ name: 'Main' }]
        });
      } catch (err) {
        setError(true);
        navigation.reset({
          index: 0,
          routes: [{ name: 'Robot' }]
        });
      }
    }

    if (route?.params?.code) {
      setTokenData();
    }
  }, [route, navigation]);

  return (
    <Container>
      {!error && (
        <View
          style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}
        >
          <ActivityIndicator size="large" color="#F2F2F2" />
        </View>
      )}
    </Container>
  );
};

export default Callback;
